import {getActivePinia,} from 'pinia'

const dismissNotification = async function ({id, dismiss, readingPlan, ids,}) {
    const { useNotificationStore, } = await import(/* webpackChunkName: "appUi" */ '@/assets/js/src/pinia/notification')

    return useNotificationStore(getActivePinia()).dismissNotification({id, dismiss, readingPlan, ids,})
}

export function useDismissNotification () {
    return {
        dismissNotification,
    }
}
